module.exports = __webpack_public_path__ + "img/OrderPickingS1Page.064dca3c.png";